import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import OrderForm from 'src/components/OrderForm/OrderForm';

export const Route = createFileRoute('/_authed/order-kit')({
  component: OrderForm,
});
